// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU';
export const WINDOW_WIDTH = 'WINDOW-WIDTH';
export const SWITCH_LANGUAGE = 'SWITCH-LANGUAGE';

//Contact Module const
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';

//Auth const
export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNIN_GOOGLE_USER = 'SIGNIN_GOOGLE_USER';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'SIGNIN_GOOGLE_USER_SUCCESS';
export const SIGNIN_FACEBOOK_USER = 'SIGNIN_FACEBOOK_USER';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'SIGNIN_FACEBOOK_USER_SUCCESS';
export const SIGNIN_TWITTER_USER = 'SIGNIN_TWITTER_USER';
export const SIGNIN_TWITTER_USER_SUCCESS = 'SIGNIN_TWITTER_USER_SUCCESS';
export const SIGNIN_GITHUB_USER = 'SIGNIN_GITHUB_USER';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_success';
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';
export const INIT_URL = 'INIT_URL';
export const GET_USER_INFO = 'GET_USER_INFO';

//User const
export const GET_USER_FROM_DB = "GET_USER_FROM_DB";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const DELETE_USER_FROM_AFFILIATES_LIST = "DELETE_USER_FROM_AFFILIATES_LIST";
export const SHOW_ERROR_MESSAGE = "SHOW_ERROR_MESSAGE";
export const ACCEPT_AFFILIATION_REQUEST = "ACCEPT_AFFILIATION_REQUEST";
export const SHOW_SUCCES_MESSAGE = "SHOW_SUCCES_MESSAGE";
export const REJECT_AFFILIATION_REQUEST = "REJECT_AFFILIATION_REQUEST";
export const GET_ALL_MAJORISTS = "GET_ALL_MAJORISTS"
export const GET_ALL_MAJORISTS_DONE = "GET_ALL_MAJORISTS_DONE"
export const GET_ALL_CLIENTS = "GET_ALL_CLIENTS";
export const GET_ALL_CLIENTS_DONE = "GET_ALL_CLIENTS_DONE";
export const DELETE_MAJOR_PRODUCT = "DELETE_MAJOR_PRODUCT";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const ADD_PRODUCT_DONE = "ADD_PRODUCT_DONE";